import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Paper, Select, InputLabel, FormControl, MenuItem, Typography,
} from '@material-ui/core';
import TrendingFlatTwoToneIcon from '@material-ui/icons/TrendingFlatTwoTone';
import Actions from '../actions';
import Drawer from './Drawer';
import SearchUserForm from './SearchUserForm';
import TaskTable from './TasksTable';

class UserReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: '',
      groupTasks: {},
      activePlan: '',
    };
    this.sortedPlans = [];
  }

    userSelected=() => {
      this.props.fetchCompletedTasks(this.props.user).then(() => {
        const groupTasks = this.groupTasks(this.props.completedTasks);
        this.setState({ groupTasks });
      });
      this.setState({ user: this.props.user });
      this.props.getUserPlans(this.props.user).then(() => {
        const plans = [];
        this.props.planAssignments.map((assignment) => {
          return plans.push(assignment.plan);
        });
        this.sortedPlans = plans.sort((a, b) => { return a.createdAt.substring(0, 10) > b.createdAt.substring(0, 10) ? -1 : 1; });
        this.setState({ activePlan: this.sortedPlans[0] });
      });
    }

    onChangeHandler=(e) => {
      this.setState({ activePlan: e.target.value });
    }

    groupTasks(tasks) {
      const groupTasks = {};
      // eslint-disable-next-line no-unused-expressions
      tasks && tasks.forEach((task) => {
        if (groupTasks[task.plan]) groupTasks[task.plan].push(task);
        else groupTasks[task.plan] = [task];
      });
      console.log(groupTasks);
      console.log(this.state.activePlan);
      return groupTasks;
    }

    render() {
      return (
        <Drawer>
          <div style={{ width: '100%' }}>
            <Paper style={{
              flexWrap: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', marginTop: 20, padding: 20,
            }}
            >
              <SearchUserForm userSelected={this.userSelected} />
              <TrendingFlatTwoToneIcon style={{ fontSize: 40 }} />
              <FormControl style={{ width: '40%', margin: 10 }}>
                <InputLabel id="simple-select-tasktype-label">Select Plan</InputLabel>
                <Select
                  value={this.state.activePlan}
                  onChange={(e) => { this.onChangeHandler(e); }}
                >
                  {this.sortedPlans && this.sortedPlans.map((plan) => {
                    return <MenuItem key={plan._id} value={plan}>{plan.name}</MenuItem>;
                  })}
                </Select>
              </FormControl>
            </Paper>
            {
              // eslint-disable-next-line no-nested-ternary
              this.state.user ? this.state.groupTasks[this.state.activePlan._id]
                ? <TaskTable completedTasks={this.state.groupTasks[this.state.activePlan._id]} />
                : <Typography variant="h6">No Tasks Completed For Selected Plan</Typography>
                : null
}
          </div>
        </Drawer>
      );
    }
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

function mapStateToProps(state) {
  return {
    user: state.user.data,
    completedTasks: state.completedTasks.data,
    planAssignments: state.planAssignments.data,
    fetching: state.planAssignments.fetching,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(UserReport);
